module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_f_normal.9d9a1c81.png";